import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownSelect } from './common/DropdownSelect';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  filters: { [key: string]: string };
  onFilterChange: (name: string, value: string) => void;
}

const FilterReportBar: React.FC<FilterBarProps> = ({ filters, onFilterChange }) => {
  const { t } = useTranslation('common');

  const statusOptions: FilterOption[] = [
    { value: '', label: t('all_statuses') },
    { value: 'pending', label: t('report_status.pending') },
    { value: 'resolved', label: t('report_status.resolved') },
    { value: 'dismissed', label: t('report_status.dismissed') },
  ];

  const contentTypeOptions: FilterOption[] = [
    { value: '', label: t('all_types') },
    { value: 'job', label: t('content_type.job') },
    { value: 'profile', label: t('content_type.profile') },
    { value: 'review', label: t('content_type.review') },
    { value: 'quote', label: t('content_type.quote') },
    { value: 'quote_request', label: t('content_type.quote_request') },
    { value: 'issue', label: t('content_type.issue') },
  ];

  return (
    <div className="flex flex-wrap gap-3 items-end justify-between px-4 py-3 border-b border-gray-300 bg-gray-50">
      {/* Statut */}
      <DropdownSelect<FilterOption>
        className="w-56"
        value={statusOptions.find(option => option.value === filters.status) ?? null}
        onChange={(_label, item) => onFilterChange('status', item?.value ?? '')}
        options={statusOptions}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value || 'all'}
        placeholder={t('all_statuses')}
      />

      {/* Type de contenu */}
      <DropdownSelect<FilterOption>
        className="w-56"
        value={contentTypeOptions.find(option => option.value === filters.content_type) ?? null}
        onChange={(_label, item) => onFilterChange('content_type', item?.value ?? '')}
        options={contentTypeOptions}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value || 'all'}
        placeholder={t('all_types')}
      />
    </div>
  );
};

export default FilterReportBar;
